import { NgModule, Optional, SkipSelf } from '@angular/core';

import { ErrorsModule } from "./errors/errors.module";

@NgModule({
  imports: [
    ErrorsModule
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if ( parentModule ) {
      throw new Error('CoreModule is alread loaded. Import it in the AppModule only.');
    }
  }
}
